import React from 'react';
import { useHistory } from "react-router";
import { getProfitAndLoss } from "api/urls";
import TableContainer from 'components/wrapper/TableContainer';

const ProfitAndLoss = (props) => {

  const { period, title } = props
  const history = useHistory()
  const unWantedKeys = period === "Y" ?
    ['as_on_date', 'created_at', 'updated_at', 'company_id', 'period', 'data_type', 'id', 'company']
    :
    ['as_on_date', 'created_at', 'updated_at', 'company_id', 'period', 'data_type', 'id', 'dividend_payout', 'eps', 'price', 'price_to_earning', 'company']


  return (
    <div >
      <TableContainer
        url={getProfitAndLoss(history.location.search, period)}
        title={title}
        unWantedKeys={unWantedKeys}
        isQuarterly={period === 'QA'}
      />
    </div>
  )
}

export default (ProfitAndLoss);
